export const CALENDAR_FIX_MODE = "fixed"
export const CALENDAR_FLEX_MODE = "flexible"

export const LEFT_CALENDAR = "left"
export const RIGHT_CALENDAR = "right"
